<template>
    <!--<el-row class="fixed" :class="{'top': top, 'move': !top}">-->
    <el-row class="header" :class="{'fixed': !top}">
        <el-col :span="8">
            <img class="logo" src="../assets/imgs/sht.jpg" />
        </el-col>
        <el-col :span="16">
            <el-row>
                <el-col :span="3" class="menu" :class="{'active': active === 'home'}" @click.native="toPage('/')">
                    首页
                </el-col>
                <el-col :span="3" class="menu" :class="{'active': active === 'news'}" @click.native="toPage('/news')">
                    新闻中心
                </el-col>
                <el-col :span="3" class="menu" :class="{'active': active === 'business'}" @click.native="toPage('/business')">
                    解决方案
                </el-col>
<!--                <el-col :span="3" class="menu" :class="{'active': active === 'party'}" @click.native="toPage('/party')">-->
<!--                    党建专题-->
<!--                </el-col>-->
                <el-col :span="3" class="menu" :class="{'active': active === 'welfare'}" @click.native="toPage('/welfare')">
                    公益事业
                </el-col>
                <el-col :span="3" class="menu" :class="{'active': active === 'about'}" @click.native="toPage('/about')">
                    关于我们
                </el-col>
                <el-col :span="3" class="menu" :class="{'active': active === 'job'}" @click.native="toPage('/jobs')">
                    人才招聘
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        props: {
            active: {
                type: String
            }
        },
        data () {
            return {
                top: true
            }
        },
        name: "Header",
        mounted() {
            window.addEventListener(
                'scroll',
                () => {
                    if (this.onPageScroll) {
                        this.onPageScroll.call(this, window.scrollY)
                    }
                },
                true
            )
        },
        destroyed() {
            window.removeEventListener('scroll', this.onPageScroll);
            delete this.onPageScroll;
        },
        methods: {
            onPageScroll(scrollY) {
                this.top = scrollY === 0;
            },
            toPage (viewPath) {
                this.$router.push({
                    path: viewPath
                });
            }
        },
        computed: {
            ...mapGetters(['isMobile'])
        }
    }
</script>

<style scoped>
    .fixed {
        position: fixed;
        top: 0;
        z-index: 1000;
        width: 100%;
    }
    .logo {
        width: auto;
        height: 70px;
        float: left;
        margin-left: 50px;
    }
    .menu {
        height: 50px;
        line-height: 50px;
        cursor: pointer;
    }
    .active {
        border-bottom: 3px solid rgb(250, 55, 5);
    }
    .top {
        color: #ffffff;
    }
    .move {
        color: #616161;
        background-color: #ffffff;
        box-shadow: 0 3px 0 0 rgba(0,0,0,.05);
    }

    .header {
        color: #616161;
        background-color: #ffffff;
        box-shadow: 0 3px 0 0 rgba(0,0,0,.05);
    }

</style>
